import ContentTemplate from 'components/common/ContentTemplate';
import PageTemplate from 'components/common/PageTemplate';
import React from 'react'
import { serviceLog20240304, serviceLog20250103 } from '../../privacyPolicyText';

const MobileNoticeTerms250103 = () => {
    const [beforeChangeTerms, setBeforeChangeTerms] = React.useState(true);
    const [afterTerms, setAfterTerms] = React.useState(true);


  return (
    <PageTemplate>
      <ContentTemplate>
        <h1 className="service_compare_title">2025 wizzap 서비스이용약관 변경 안내</h1>
        <p> - 변경 약관 고지일 : 2025.01.03 ~ 01.10(7일 간)</p>
        <p>- 변경 약관 적용일 : 2025.01.10부터</p>
        <br />
        <div>
          <p>2025년 wizzap 서비스이용약관의 일부 내용이 변경되오니 공지 내 변경약관 전문을 확인해 주시기 바랍니다.</p>
          <p>개정되는 약관에 동의하지 않으시는 경우에는 회원탈퇴(이용계약의 해지)를 요청하실 수 있습니다.</p>
          <p>사전공지 기한 내에 변경 약관의 적용에 대해 거절의 의사를 표시하지 않으면 동의한 것으로 간주합니다.</p>
          <br />
          <p> - 주요 변경 내용</p>
          <p> ① 제12조 회원자격 정지 기준 및 기간 명시</p>
          <p> ② 제13조 회원탈퇴 기준 강화</p>
          <p> ③ 제28조 회원의 의무 세부항목 추가</p>
        </div>
        <br />

        <div className="change_box" onClick={() => setBeforeChangeTerms(!beforeChangeTerms)}>
          <span className="service_compare">변경 전</span>
        </div>
        {beforeChangeTerms && (
          <div className="service_box">
            {serviceLog20240304.map((item, idx) => (
              <p className="service_text" key={idx}>{item}</p>
            ))}
                
          </div>
        )}
        <hr />
        <div className="change_box" onClick={() => setAfterTerms(!afterTerms)}>
          <span className="service_compare">변경 후</span>
        </div>

        {afterTerms && (
          <div className="service_box">
            {serviceLog20250103.map((item, idx) => (
              <p className="service_text" key={idx}>{item}</p>
            ))}
          </div>
        )}

        <img src="/v2/imgs/img-wordmark-black.png" alt="wordmark" style={{ width: "100px" }} />
      </ContentTemplate>
    </PageTemplate>
  )
}

export default MobileNoticeTerms250103